// Structured data schemas for different page types
export const createWebsiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Story Bunny',
  description: 'Create magical AI-powered stories for children',
  url: 'https://storybunny.ai',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://storybunny.ai/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Story Bunny AI LLC',
    url: 'https://storybunny.ai',
  },
})
export const createOrganizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Story Bunny AI LLC',
  url: 'https://storybunny.ai',
  logo: 'https://storybunny.ai/logo.png',
  description: 'AI-powered storytelling platform for children',
  foundingDate: '2025',
  founder: {
    '@type': 'Person',
    name: 'Grace Lee',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'support@storybunny.ai',
    contactType: 'customer service',
  },
})
export const createSoftwareApplicationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Story Bunny',
  description:
    "AI-powered storytelling tool for creating children's illustrated storybooks",
  url: 'https://storybunny.ai',
  applicationCategory: 'EducationalApplication',
  operatingSystem: 'Web Browser',
  offers: {
    '@type': 'Offer',
    price: '7.00',
    priceCurrency: 'USD',
    priceValidUntil: '2026-12-31',
    availability: 'https://schema.org/InStock',
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    ratingCount: '150',
  },
})
export const createFAQSchema = (
  faqs: Array<{ question: string; answer: string }>,
) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
})
export const createServiceSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'AI Story Creation for Children',
  description:
    'Create personalized, illustrated storybooks for children using AI technology',
  provider: {
    '@type': 'Organization',
    name: 'Story Bunny AI LLC',
  },
  serviceType: 'Educational Technology',
  audience: {
    '@type': 'Audience',
    audienceType: 'Children ages 3-6',
  },
})
export const createPricingSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'Story Bunny Credits',
  description: "Credit pack for creating AI-powered children's stories",
  offers: [
    {
      '@type': 'Offer',
      name: '5 Story Credits',
      price: '4.00',
      priceCurrency: 'USD',
      description: '5 custom storybooks - less than $1 per book',
    },
  ],
})
